<div class="header">
  <div class="titles">
    <h2>{{ datasetName }}</h2>
    <p *ngIf="dataLoaded" class="timestamps">{{ metainfoTimestamps }}</p>
  </div>
  <button mat-icon-button mat-dialog-close><mat-icon svgIcon="close"></mat-icon></button>
</div>
<mat-dialog-content class="metainfo-grid">
  <ng-container *ngIf="hasMetainfoSet; else noMetainfoSet">
    <ng-container *ngIf="dataLoaded; else metainfoLoading">
      <div class="left-side">
        <div class="full-title-block metainfo-block">
          <h4 class="title">Short description</h4>
          <div class="short-description">{{ short_description }}</div>
          <div *ngIf="dataset_type_explanation" class="short-description"><br><i>{{ dataset_type_explanation }}</i>
          </div>
        </div>
      </div>

      <div class="right-side">
        <div class="license metainfo-block">
          <h4 class="title">License</h4>
          <div>
            {{ metainfo!.license || 'No license set' }}
          </div>
        </div>

        <div class="timespan metainfo-block" *ngIf="metainfo!.timespan">
          <h4 class="title">Data timespan</h4>
          <div class="data-timespan">
            {{ metainfoTimespan }}
          </div>
        </div>

        <div class="external-references metainfo-block">
          <h4 class="title">External references</h4>
          <div class="references">
            <mat-chip-set>
              <mood-metainfo-reference *ngFor="let reference of externalReferences"
                [reference]="reference"></mood-metainfo-reference>
            </mat-chip-set>
          </div>
        </div>

        <div class="metainfo-block">
          <h4 class="title">Providers</h4>
          <div class="providers">
            <mat-chip-set>
              <mood-metainfo-provider *ngFor="let provider of providers" [provider]="provider"></mood-metainfo-provider>
            </mat-chip-set>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="description-block metainfo-block">
          <h4 class="title">Full Description</h4>
          <div class="description">{{ metainfo!.description }}</div>
        </div>

        <div class="processing-block metainfo-block" *ngIf="metainfo!.processing">
          <h4 class="title">Processing steps</h4>
          <div class="processing">{{ metainfo!.processing }}</div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions>
  <!-- <button mat-button>Edit</button> -->
  <button mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>

<ng-template #noMetainfoSet>
  <mood-info-message
    message="Metadata could not be loaded, it's possible this dataset has no GeoNetwork ID set yet."></mood-info-message>
</ng-template>

<ng-template #metainfoLoading>
  Please wait, metainfo is loading...
</ng-template>
